module.exports = __webpack_public_path__ + "static/img/pexels.d6f7a17.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/company/pexels.png
// module id = 1XVT
// module chunks = 1